export const DEST = Object.freeze({
  VEHICLE: 'VEHICLE',
  SERVICE: 'SERVICE',
  APPT: 'APPT',
  SH: 'SH',
  ST: 'ST'
});

export const KIND = Object.freeze({
  IS_SSO: 'IS_SSO',
  AUTO_LOGIN: 'AUTO_LOGIN',
  MARKETING: 'MARKETING',
  APPT_FIND: 'APPT_FIND',
  SAB: 'SAB',
  NEW_VEHICLE: 'NEW_VEHICLE'
});

export const NEW_APPT = 'NEW_APPT';



// WEBPACK FOOTER //
// ./src/constants/deeplink.js